function scrollAnimation() {
    const scrollItems = document.querySelectorAll(".animation--scroll-trigger");
        const delayInterval = 100;
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("animation--fade-in");

                    const children = entry.target.querySelectorAll(".animation--animate-slide-in");
                    children.forEach((child, index) => {
                        setTimeout(() => {
                            child.classList.add("animation--fade-in");
                        }, index * delayInterval);
                    });

                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.2 });

        scrollItems.forEach(item => observer.observe(item));
  }
  
  document.addEventListener("DOMContentLoaded", () => {
    scrollAnimation();
  });